import React, { ReactElement } from 'react';
import { addParamsToContentfulImage, ImageParams, transformImageParams } from '../contentful-image';

type Profile = {
  width: number;
  height: number;
  rule: string;
};

export interface ContentfulPictureProps {
  url: string;
  alt: string;
  profiles: Profile[];
  className?: string;
  imageId?: string;
}

export const ContentfulPicture = ({
  url,
  alt,
  profiles,
  className = '',
  imageId = '',
}: ContentfulPictureProps): ReactElement => {
  const imagePath = (params: ImageParams) =>
    addParamsToContentfulImage(url, transformImageParams(params));

  const imagePathRetinas = ({ width, height, ...params }: ImageParams) => {
    const image1x = imagePath({ width, height, ...params });
    const image2x = imagePath({
      width: width * 2,
      height: height * 2,
      ...params,
    });

    return `${image1x} 1x, ${image2x} 2x`;
  };

  const defaultImage = imagePath(profiles[0]);

  const id = imageId ? `image-${imageId}` : undefined;

  return (
    <>
      <picture className="picture">
        {profiles.map((profile) => (
          <source
            key={`${url}_${profile.height}_${profile.width}_${profile.rule}`}
            media={profile.rule}
            srcSet={`${imagePathRetinas(profile)}&fn=webp`}
          />
        ))}
        <img
          className={`picture__image ${className}`}
          src={`${defaultImage}&fm=webp`}
          alt={alt}
          id={id}
        />
      </picture>
    </>
  );
};
